import {IDonorDTO, IDonorSex, IExternalDonorDTO} from "../../../types/IDonorDTO";
import { AppointmentTime } from "../../../types/AppointmentTime";
import { IAccount } from "../../../types/IAccount";
import { ILocation } from "../../../types/ILocation";
import { IBloodDrive } from "types/IBloodDrive";

export interface IDonorEligibilityDate {
   appointmentType: string;
   eligibleDate: string;
   appointmentTypeDescription: string;
}

export interface IDonorAppointmentDTO {
   appointmentId: string;
   appointmentDate: Date;
   appointmentTime: AppointmentTime;
   canceled: boolean;
   appointmentType: string;
   account: IAccount;
   location: ILocation;
   madeBy: "Staff" | "Donor";
}

export interface IPhysicalExamReading {
   hemoglobin: number;
   hematocrit: number;
   bloodPressureSystolic: number;
   bloodPressureDiastolic: number;
   pulse: number;
   temperature: number;
}
export interface IPhysicalExamData {
   height: number;
   weight: number;
   CuS04: string;
   firstReading: IPhysicalExamReading;
   secondReading: IPhysicalExamReading;
}

export type DonationOutcome = "Successful" | "Failed" | "Deferred";
export const DonationOutcomes: DonationOutcome[] = [
   "Successful",
   "Failed",
   "Deferred",
];
export interface IDonorDonationDTO {
   date: string;
   donationProcedure: string;
   donationProcedureDescription: string;
   // include account name (SCREDP-53)
   drive: IBloodDrive;
   location: ILocation;
   physicalExam: IPhysicalExamData;
   creditToLocation: ILocation;
   outcome: DonationOutcome;
}

export interface IDonorContactPreference {
   contactPreferenceCode: string;
   contactPreferenceDescription: string;
}

export interface IDonorQRCodeInterface {
   width: string;
   height: string;
   type: string;
}

export interface IDonorValidationRequest {
   firstName: string;
   lastName: string;
   emailAddress: string;
   donorId: number;
   dateOfBirth: string;
   phoneNumber: string;
}

export interface IDonorIdEmailVerificationRequest {
   email: string;
   donorId: string;
}

export interface IDonorDataService {
   getDonor(donorId: string): Promise<IDonorDTO>;
   getExternalDonor(externalDonorId: string): Promise<IExternalDonorDTO>;
   getDonorEligibilityDates(donorId: string): Promise<IDonorEligibilityDate[]>;
   getDonorAppointment(
      donorId: string,
      appointmentId: string,
   ): Promise<IDonorAppointmentDTO>;
   getDonorAppointments(donorId: string): Promise<IDonorAppointmentDTO[]>;
   getDonorDonations(donorId: string): Promise<IDonorDonationDTO[]>;
   getDonorIdCard(
      donorId: string,
      qrcodeParameters: IDonorQRCodeInterface,
   ): Promise<Blob>;
   getDonorContactPreferences(
      donorId: string,
   ): Promise<IDonorContactPreference[]>;
   setDonorContactPreferences(
      donorId: string,
      preferences: IDonorContactPreference[],
      // SCREDP-112 - Prevent multiple submissions while save request operations are executing
      startLoading,
      stopLoading
   ): Promise<void>;
   validateDonor(
      validationRequest: IDonorValidationRequest,
      // SCREDP-112 - Prevent multiple submissions while save request operations are executing
      startLoading?,
      stopLoading?
   ): Promise<string>;
   getSexOptions(): Promise<IDonorSex[]>;
   verifyDonorIdForEmail(verifcationRequest: IDonorIdEmailVerificationRequest): Promise<boolean>;
}
